import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import actions from "actions";
import { UserListWebinar } from "components/AddUsersWebinar/UserListWebinar.jsx";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import ToolbarNewWebinar from "components/AddUsersWebinar/index";
import { getAdminStudygroup } from "../../../actions/studygroups";

const {
  showDeleteUsersConfirmationModal,
  adminUserFilter,
  sendGroupInvites,
  getStudygroup,
  getAdminGroupMembers,
} = actions;

class AddGroupMembers extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.timer = true;

    this.state = {
      user_ids:
        props.members.map((member) => ({
          id: member.id,
          email: member.email,
        })) || [],
      per_page: 50,
      page: props.page || 1,
      searchQuery: {
        order: {
          created_at: "desc",
        },
        ...props.query,
      },
      startDate: null,
      endDate: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { members } = this.props;

    if (nextProps.total_pages != this.props.total_pages) {
      this.setState({
        page: 1,
      });
    }

    if (nextProps.members.length !== members.length) {
      const ids = nextProps.members.map((member) => ({
        id: member.id,
        email: member.email,
      }));

      this.setState({ user_ids: ids });
    }
  }
  // componentDidMount = () => {
  //   window.scrollTo(0, 0);
  // }

  componentWillMount = () => {
    const { loadStudyGroup, getGroupMembers, params } = this.props;
    const { id } = params;

    this.updateUsersList();
    loadStudyGroup(id);
    getGroupMembers(id);
  };

  deleteUsers = () => {
    if (this.state.user_ids.length > 0)
      this.props.deleteUsers(this.state.user_ids.map((user) => user.id));
  };

  onChangePage = (page = 1) => {
    this.setState(
      {
        page,
      },
      this.updateUsersList
    );
  };

  onOrderChange = (field = "created_at", order = "desc") => {
    const searchQuery = {
      ...this.state.searchQuery,
      order: {
        [field]: order,
      },
    };
    this.setState(
      {
        searchQuery,
      },
      this.updateUsersList
    );
  };

  checkedUserIds = (user_id, email) => {
    const ids = [...this.state.user_ids];
    const index = ids.findIndex((item) => item.id === user_id);

    if (index === -1) {
      this.setState({
        user_ids: [...ids, { id: user_id, email }],
      });
    } else {
      this.setState({
        user_ids: ids.filter((item) => item.id !== user_id),
      });
    }
  };

  changeFilterQuery = (field, value) => {
    const query = { ...this.state.searchQuery, ...{ [field]: value } };
    this.setState({ searchQuery: query, page: 1 }, () => {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.updateUsersList, 500);
    });
  };

  updateUsersList = () => {
    const { page, searchQuery } = this.state;

    this.props.userFilter(searchQuery, page);
  };

  onAddCheckedUsersClick = () => {
    const { params, sendGroupInvites } = this.props;
    const { user_ids } = this.state;
    const usersEmail = user_ids.map((user) => user.email);

    sendGroupInvites(params.id, usersEmail);
  };

  render() {
    const { changeFilterQuery, deleteUsers } = this;

    console.log(this.state.user_ids);

    return (
      <main className="site--width container_statistics">
        <ToolbarNewWebinar
          filterProps={{
            ...this.state,
            changeFilterQuery,
            // setState,
          }}
          toolsProps={{
            ...this.state,
            onAddCheckedUsersClick: this.onAddCheckedUsersClick,
            deleteUsers,
            count: this.props.count,
          }}
        />
        <div className="admin_user_table admin_table">
          <UserListWebinar
            query={this.state.searchQuery}
            users={this.props.users}
            checkedUserIds={this.checkedUserIds}
            user_ids={this.state.user_ids.map((user) => user.id)}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages,
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    members: state.studygroups.groupMembers.values,
    users: state.users.adminUsers.values,
    count: state.users.adminUsers.count,
    total_pages: state.users.adminUsers.total_pages,
    page: state.users.adminUsers.page,
    query: state.users.adminUsers.query,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    deleteUsers: (user_ids) =>
      dispatch(showDeleteUsersConfirmationModal(user_ids)),
    userFilter: (query, page) => dispatch(adminUserFilter(query, page)),
    sendGroupInvites: (groupId, emails) =>
      dispatch(sendGroupInvites(groupId, emails)),
    loadStudyGroup: (id) => dispatch(getAdminStudygroup(id)),
    getGroupMembers: (id) => dispatch(getAdminGroupMembers(id)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddGroupMembers);



// WEBPACK FOOTER //
// ./src/containers/Admin/StudyGroups/AddGroupMembers.jsx